import type {
	CustomItem,
	DropTextSectionType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropTextSection = (
	item: Item | CustomItem
): item is DropTextSectionType => {
	return !!(item && item.__typename === 'Drop_Text_Section');
};
